import componentKeys from "@/helpers/wc/componentKeys";
import defaultPosition from "@/helpers/wc/positionSettings";

export const DepartmentUsersSortModeEnum = Object.freeze({
  DEACTIVATED: "DEACTIVATED",
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME"
});

export const departmentUsersSettings = {
  title: "Department Users",
  [componentKeys.name]: "departmentUsersBase",

  [componentKeys.styles]: defaultPosition,

  [componentKeys.properties]: {
    [componentKeys.routeName]: "",
    [componentKeys.employeesCount]: 6,
    [componentKeys.jobDepartment]: "",
    [componentKeys.messageToEmployee]: {},
    [componentKeys.fetchFromDepartment]: false,
    [componentKeys.showName]: true,
    [componentKeys.showJobTitle]: false,
    [componentKeys.showPhone]: true,
    [componentKeys.breakLine]: false,
    [componentKeys.messageTagVisitorCompany]: false,
    [componentKeys.messageTagVisitorName]: false,
    [componentKeys.messageTagVisitorPhone]: false,
    [componentKeys.messageTagVisitorAttendants]: false,
    [componentKeys.sendSms]: false,
    [componentKeys.sendEmail]: false,
    [componentKeys.redirectToRegister]: false,
    departmentUsersSortMode: DepartmentUsersSortModeEnum.DEACTIVATED,
    enablePagination: false,
    css: {
      departmentUsers: {
        color: "#000000",
        fontFamily: "sans-serif",
        textAlign: "left",
        fontSize: "16px",
        userItemWidth: "25%",
        justifyContent: "center",
      },
      userItemInnerSpacing: {
        paddingTop: "0",
        paddingRight: "15px",
        paddingBottom: "0",
        paddingLeft: "15px",
      },
      userItemImageBorder: {
        style: "none",
        width: "0",
        color: "none",
        radius: "0",
      },
      pagination: {
        "--pagination-color": "#f83d3d"
      }
    },
  },
  cssLegend: {
    departmentUsers: {
      name: 'root',
      color: {
        type: 'color',
        name: 'color'
      },
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      textAlign: {
        type: 'align',
        name: 'textAlign'
      },
      fontSize: {
        type: 'int',
        name: 'fontSizePx',
        handler: val => val + 'px'
      },
      userItemWidth: {
        type: 'int',
        name: 'userItemWidthPercents',
        handler: val => val + '%'
      },
      justifyContent: {
        name: 'itemJustify',
        type: 'flexJustify'
      }
    },
    userItemInnerSpacing: {
      name: 'userItemInnerSpacing',
      paddingTop: {
        name: 'paddingTopPx',
        type: 'int',
        handler: val => val + 'px'
      },
      paddingLeft: {
        name: 'paddingLeftPx',
        type: 'int',
        handler: val => val + 'px'
      },
      paddingBottom: {
        name: 'paddingBottomPx',
        type: 'int',
        handler: val => val + 'px'
      },
      paddingRight: {
        name: 'paddingRightPx',
        type: 'int',
        handler: val => val + 'px'
      },
    },
    userItemImageBorder: {
      name: 'userItemImageBorder',
      style: {
        name: 'style',
        type: 'borderStyle'
      },
      width: {
        name: 'widthPx',
        type: 'int',
        handler: val => val + 'px'
      },
      color: {
        name: 'color',
        type: 'color',
      },
      radius: {
        name: 'radiusPercents',
        type: 'int',
        handler: val => val + '%'
      }
    },
    pagination: {
      name: 'pagination',
      '--pagination-color': {
        name: 'color',
        type: 'color'
      }
    }
  }
};
